<script setup>
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useStore } from 'vuex';
import { useAlert } from 'dashboard/composables';

import Dialog from 'dashboard/components-next/dialog/Dialog.vue';
import Button from 'dashboard/components-next/button/Button.vue';

const props = defineProps({
  campaign: {
    type: Object,
    default: null,
  },
});

const { t } = useI18n();
const store = useStore();

const dialogRef = ref(null);
const isDeleting = ref(false);

const open = () => {
  dialogRef.value?.open();
};

const close = () => {
  dialogRef.value?.close();
};

const handleDelete = async () => {
  if (!props.campaign) return;

  isDeleting.value = true;

  try {
    await store.dispatch('whatsappCampaigns/delete', props.campaign.id);
    useAlert(t('WHATSAPP_BROADCAST.API.DELETE_SUCCESS'));
    close();
  } catch (error) {
    useAlert(t('WHATSAPP_BROADCAST.API.ERROR'));
  } finally {
    isDeleting.value = false;
  }
};

defineExpose({ open, close });
</script>

<template>
  <Dialog
    ref="dialogRef"
    :title="t('WHATSAPP_BROADCAST.DELETE.TITLE')"
    size="small"
  >
    <p class="text-sm text-n-slate-11">
      {{ t('WHATSAPP_BROADCAST.DELETE.DESCRIPTION') }}
    </p>
    <p v-if="campaign" class="mt-2 font-medium text-n-slate-12">
      "{{ campaign.title }}"
    </p>

    <template #footer>
      <div class="flex justify-end gap-2">
        <Button variant="ghost" color-scheme="secondary" @click="close">
          {{ t('WHATSAPP_BROADCAST.DELETE.CANCEL') }}
        </Button>
        <Button color-scheme="ruby" :loading="isDeleting" @click="handleDelete">
          {{ t('WHATSAPP_BROADCAST.DELETE.CONFIRM') }}
        </Button>
      </div>
    </template>
  </Dialog>
</template>
